<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* --- ESTILOS GLOBALES / UI KIT --- */
html, body {
  height: 100%;
  margin: 0;
  overflow: hidden; /* Evita doble scroll, el scroll estará dentro de la tabla */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  background-color: #f4f7f9;
  color: #333;
}

#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Layout Básico Flexible */
.container {
  width: 95%; /* Un poco más ancho para aprovechar espacio */
  max-width: 1400px;
  height: calc(100vh - 4rem); /* Altura total menos los márgenes superior e inferior (2rem + 2rem) */
  margin: 2rem auto;
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  
  /* Convertimos el container en una caja flexible vertical */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

h1 {
  color: #2c3e50;
  margin: 0;
}

/* --- ELEMENTOS DE FORMULARIO BASE --- */
.form-group {
    margin-bottom: 1rem;
}
.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
}
.form-group input, .form-group textarea, .form-group select {
    width: 100%;
    padding: 8px 12px;
    box-sizing: border-box; 
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
    font-family: inherit;
}

/* --- BOTONES GENÉRICOS --- */
.btn-primary,
.modal-actions button[type="submit"], 
.btn-download,
.upload-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  text-decoration: none; 
  display: inline-block; 
  font-weight: 500;
}
.btn-primary:hover,
.modal-actions button[type="submit"]:hover, 
.btn-download:hover,
.upload-btn:hover {
  background-color: #0056b3;
}

.btn-secondary,
.modal-actions button[type="button"] {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;
}
.btn-secondary:hover,
.modal-actions button[type="button"]:hover {
  background-color: #e0e0e0;
}

button:disabled,
.modal-actions button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* --- MODAL BASE --- */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    overflow-y: auto; 
    padding: 2rem;
    box-sizing: border-box;
}
.modal-content {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    width: 500px;
    max-width: 90%;
    box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    max-height: 90vh; 
    overflow-y: auto; 
}
.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #eee; 
}

/* Badges de Estado */
.status-badge, .status-badge-table {
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.85em;
  display: inline-block;
}
.status-aprobado { background-color: #d1fae5; color: #065f46; }
.status-descartado { background-color: #fee2e2; color: #991b1b; }
.status-pendiente { background-color: #fef3c7; color: #92400e; }
</style>